export enum FileType {
    XLXS = 'xlsx',
    PDF = 'pdf',
    CSV = 'csv'
}